import { useTranslation } from 'react-i18next'
import { App, Form, Input } from 'antd';
import { useImperativeHandle, forwardRef } from 'react';
import { useSearchParams } from 'react-router-dom'
import { importWhoDrugB3 } from '@/api/dictionary'
import CustomUpload from './customUpload';

const WhoDrugB3Form = (props, ref: any)=> {
    const { t } = useTranslation()
    const [form] = Form.useForm()
    const [searchParams] = useSearchParams()
    const dictName = searchParams.get('dictName') || ''
    const { message } = App.useApp();

    const onFinish = async ()=>{
        try {
            const values = await form.validateFields()
            const params = new FormData()
            params.append('ddFile', values.ddFile.file);
            params.append('bnaFile', values.bnaFile.file);
            params.append('inaDirFile', values.inaDirFile.file);
            params.append('ccodeFile', values.ccodeFile.file);
            params.append('ddaFile', values.ddaFile.file);
            params.append('ddsourceFile', values.ddsourceFile.file);
            params.append('ingFile', values.ingFile.file);
            await importWhoDrugB3(dictName, values.version, params);
            message.success(t('ikg.success', { action: t('dict.addVersion') }))
          } catch (error) {
            throw error
          }
    }

    useImperativeHandle(ref, () => {
        return {
          submit: onFinish,
          resetFields: ()=> {form.resetFields()}
        };
      }, []);

    return <Form
        layout="vertical"
        form={form}
        autoComplete="off"
        initialValues={{
            dictName
        }}
    >
        <Form.Item
            label={t('dict.dictName')} // 字典名称
            name="dictName"
        >
            <Input disabled />
        </Form.Item>
        <Form.Item
        label={t('dict.version')} // 字典名称
        name="version"
        rules={[
            {
            required: true,
            message: t('ikg.input', { name: t('dict.version') }),
            },
        ]}
        >
            <Input placeholder={t('ikg.input', { name: t('dict.version') })} />
        </Form.Item>
        <Form.Item label={t('dict.ddcsv')} name="ddFile" rules={[
            {
            required: true,
            message: t('ikg.input', { name: t('dict.ddcsv') }),
            },
        ]}>
            <CustomUpload accept=".csv" fileName='DD.csv' />
        </Form.Item>
        <Form.Item label={t('dict.bnacsv')} name="bnaFile" rules={[
            {
            required: true,
            message: t('ikg.input', { name: t('dict.bnacsv') }),
            },
        ]}>
            <CustomUpload accept=".csv" fileName='BNA.csv' />
        </Form.Item>
        <Form.Item label={t('dict.inacsv')} name="inaDirFile" rules={[
            {
            required: true,
            message: t('ikg.input', { name: t('dict.inacsv') }),
            },
        ]}>
            <CustomUpload accept=".csv" fileName='INA.csv' />
        </Form.Item>
        <Form.Item label={t('dict.ccodecsv')} name="ccodeFile" rules={[
            {
            required: true,
            message: t('ikg.input', { name: t('dict.ccodecsv') }),
            },
        ]}>
            <CustomUpload accept=".csv" fileName='CCODE.csv' />
        </Form.Item>
        <Form.Item label={t('dict.ddacsv')} name="ddaFile" rules={[
            {
            required: true,
            message: t('ikg.input', { name: t('dict.ddacsv') }),
            },
        ]}>
            <CustomUpload accept=".csv" fileName='DDA.csv' />
        </Form.Item>
        <Form.Item label={t('dict.ddsourcecsv')} name="ddsourceFile" rules={[
            {
            required: true,
            message: t('ikg.input', { name: t('dict.ddsourcecsv') }),
            },
        ]}>
            <CustomUpload accept=".csv" fileName='DDSOURCE.csv' />
        </Form.Item>
        <Form.Item label={t('dict.INGcsv')} name="ingFile" rules={[
            {
            required: true,
            message: t('ikg.input', { name: t('dict.INGcsv') }),
            },
        ]}>
            <CustomUpload accept=".csv" fileName='ING.csv' />
        </Form.Item>
    </Form>
}

export default forwardRef(WhoDrugB3Form)
